import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ScrollToBlock.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM } from '../../utils';
import { useHistory } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
var ScrollToBlock = function ScrollToBlock(_ref) {
  var params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var scrollElemId = params['Anchor Url Parameter'] || '';
  var myRef = React.useRef(null);
  var _useInView = useInView({
      rootMargin: '0px 0px 0px 0px',
      triggerOnce: false
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    check = _React$useState2[0],
    setCheck = _React$useState2[1];
  React.useEffect(function () {
    if (!inView && check) {
      setTimeout(function () {
        if (myRef && myRef.current) {
          myRef.current.scrollIntoView();
        }
      }, 1000);
      setCheck(false);
    }
  }, [inView]);
  React.useEffect(function () {
    if (canUseDOM) {
      setHref();
    }
    if (myRef && myRef.current) {
      myRef.current.scrollIntoView();
    }
  }, []);
  var setHref = function setHref() {
    if (!scrollElemId) {
      return;
    }
    var scrollElem = document.getElementById(scrollElemId);
    if (!scrollElem) {
      return;
    }

    // history.location.search, if defined, will already include the `?` character, no need to add it.
    var url = "".concat(history.location.pathname).concat(history.location.search, "#").concat(scrollElemId);
    // Use `history.push` here instead of `window.location.href` as `window.location.href` will
    // cause the page to "scroll"/jump to the named anchor value and change the browser URL bar.
    // Using just `history.push` will only change the browser URL bar, it doesn't scroll/jump to
    // the named anchor.
    // We need to manually set the scroll position due to header nav being sticky/fixed and obstructing
    // scrolled contents on both mobile and desktop.
    history.push(url);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "scroll-to-block"
  }, /*#__PURE__*/React.createElement("div", {
    ref: myRef
  }), /*#__PURE__*/React.createElement("div", {
    id: scrollElemId,
    ref: ref
  }));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "c8ugvup";
var ltrStyles = "l1dtod0s";
var rtlStyles = "r1q3lrqb";
export default ScrollToBlock;